import { fiboAPIClient } from '../fiboAPIClient';
import { FIBO_QUERY_KEYS } from './keys';
import type { FiboSearchRequest } from './types';

import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { isEmpty } from 'es-toolkit/compat';

export const FIBO_QUERIES = {
  getFiboSearch: (params?: FiboSearchRequest) =>
    queryOptions({
      queryKey: FIBO_QUERY_KEYS.search(params),
      queryFn: () => fiboAPIClient.getFiboSearch(params),
      enabled: !isEmpty(params?.s),
      placeholderData: keepPreviousData,
    }),
};
